import loadable from '@loadable/component';

export const HairAnalyser = loadable(() => import('./HairAnalyser'), {
  ssr: true,
});
